/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-useless-return */

// react imports
import { useState, useEffect } from "react";

// react-router imports
import { useNavigate } from "react-router-dom";

// @mui imports
import { Card, Grid, Icon, NativeSelect, Divider } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// notistack imports
import { useSnackbar } from "notistack";

// uuid import
import uuid from "react-uuid";

// Context imports
import { useMaterialUIController, setCurrentStudy, setDisplayName } from "context";

// firebase imports
import {
  getDocs,
  getDoc,
  doc,
  updateDoc,
  arrayUnion,
  collection,
  query,
  where,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../../../../Firebase";

function TrackingSheet() {
  const [controller, dispatch] = useMaterialUIController();
  const { currentStudy, userStudies, displayName } = controller;

  const navigate = useNavigate();

  const [trackingMap, setTrackingMap] = useState([]);
  const [state, setState] = useState("choose_study");

  const [trackingArray, setTrackingArray] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  // const [status, setStatus] = useState("default");
  // const [comment, setComment] = useState("");

  // const [shipping, setShipping] = useState(false);

  // const shippingCoLinks = {
  //   fedex: "https://www.fedex.com/fedextrack/",
  //   ups: "https://www.ups.com/track",
  //   usps: "https://tools.usps.com/go/TrackConfirmAction_input",
  //   dhl: "https://www.dhl.com/tracking.html",
  // };

  // const newDate = new Date();
  // const stringDate = newDate.toLocaleDateString("en-us", {
  //   weekday: "long",
  //   year: "numeric",
  //   month: "short",
  //   day: "numeric",
  // });

  // useEffect(() => {
  //   if (status === "shipped") {
  //     setShipping(true);
  //   } else {
  //     setShipping(false);
  //   }
  // }, [status]);

  useEffect(() => {
    const getUserDetails = async () => {
      const localStorageName = window.localStorage.getItem("userName");

      if (localStorageName === undefined || localStorageName === null) {
        const authUser = getAuth().currentUser;
        const userDoc = doc(db, "USERS", authUser.email);
        const userDetails = await getDoc(userDoc);
        window.localStorage.setItem("userName", userDetails.data().firstName);
      }

      setDisplayName(dispatch, localStorageName);
    };
    getUserDetails();
  }, [displayName]);

  useEffect(() => {
    const setOrderNumbers = async () => {
      const orderDocs = collection(db, `${currentStudy}_ORDERS`);

      const q = query(orderDocs, where("status", "!=", "shipped"));

      const newDoc = await getDocs(q);
      const parsedDocs = newDoc.docs.map((el) => ({ ...el.data(), id: el.id }));

      const trackingDocs = parsedDocs.map((el) => ({
        id: el.orderId,
        shippingCo: "fedex",
        tracking: "",
      }));
      setTrackingArray(trackingDocs);

      setTrackingMap(parsedDocs);
    };
    setOrderNumbers();
  }, [currentStudy]);

  const setTrackingNumb = (id, numb) => {
    const updatedTrackingArray = trackingArray.map((obj) => {
      if (obj.id === id) {
        return { ...obj, tracking: numb };
      }

      return obj;
    });

    setTrackingArray(updatedTrackingArray);
  };

  const setShippingCo = (id, company) => {
    const updatedTrackingArray = trackingArray.map((obj) => {
      if (obj.id === id) {
        return { ...obj, shippingCo: company };
      }

      return obj;
    });

    setTrackingArray(updatedTrackingArray);
  };

  const saveAll = async () => {
    // trackingArray.forEach((element) => {
    //   const today = new Date();

    //   if (element.tracking.length === 0 || element.shippingCo.length === 0) {
    //     return;
    //   }

    //   if (element.tracking.length !== 0 && element.shippingCo.length !== 0) {
    //     const orderInfo = trackingMap.filter((obj) => obj.orderId === element.id);

    //     const timelineItem = {
    //       id: uuid().substring(0, 10),
    //       timeStamp: today,
    //       status: "shipped",
    //       statusTitle: "shipped",
    //       statusDetails: `${orderInfo[0].orderId} has been shipped. Status changed by ${displayName}`,
    //       statusColor: "success",
    //       statusIcon: "local_shipping",
    //       comment: { title: "", details: "" },
    //       isLast: true,
    //     };

    //     console.log(timelineItem);

    //     const orderDocRef = doc(db, `${currentStudy}_ORDERS`, element.id);

    //     const updateBody = {
    //       lastModified: today,
    //       status: "shipped",
    //       statusDetails: `${orderInfo[0].orderId} has been shipped. Status changed by ${displayName}`,
    //       statusColor: "success",
    //       statusTimeline: arrayUnion(timelineItem),
    //     };

    //     console.log(updateBody);

    //     await updateDoc(orderDocRef, updateBody);

    //     const sendmailApi =
    //       "https://q1bgx99bv9.execute-api.us-east-1.amazonaws.com/default/storefront_sendmail_orderflow";

    //     const shippingCoLinks = {
    //       fedex: "https://www.fedex.com/fedextrack/",
    //       ups: "https://www.ups.com/track",
    //       dhl: "https://www.dhl.com/tracking.html",
    //     };

    //     const body = JSON.stringify({
    //       senderName: displayName,
    //       senderEmail: element.orderFor,
    //       senderOrderNumb: element.orderId,
    //       senderStudy: element.storeData.title,
    //       senderRoute: "order-shipped",
    //       senderTrackingNumb: trackingObj.tracking,
    //       senderTrackingLink: shippingCoLinks[trackingObj.shippingCo],
    //     });

    //     console.log("BODY >>>", body);

    //     const requestOptions = {
    //       method: "post",
    //       body,
    //     };

    //     fetch(sendmailApi, requestOptions)
    //       .then((response) => {
    //         if (!response.ok) throw new Error("Error in fetch");
    //         return response.json();
    //       })
    //       .then((response) => {
    //         console.log(response);
    //         console.log("Sent to Lambda successfully!");
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         console.log("Email didn't work!");
    //       });

    //     const variant = "success";
    //     enqueueSnackbar(`${element.orderId}'s status has been updated!`, {
    //       variant,
    //       autoHideDuration: 2000,
    //     });
    //   }
    // });

    for (const element of trackingMap) {
      const today = new Date();

      const shippingCoLinks = {
        fedex: "https://www.fedex.com/fedextrack/",
        ups: "https://www.ups.com/track",
        dhl: "https://www.dhl.com/tracking.html",
      };

      const trackingObj = trackingArray.find((obj) => obj.id === element.orderId);

      if (trackingObj.tracking.length === 0 || trackingObj.shippingCo.length === 0) {
        console.log("Zeros all around");
      }

      if (trackingObj.tracking.length !== 0 && trackingObj.shippingCo.length !== 0) {
        const timelineItem = {
          id: uuid().substring(0, 10),
          timeStamp: today,
          status: "shipped",
          statusTitle: "shipped",
          statusDetails: `${element.orderId} has been shipped. Status changed by ${displayName}`,
          statusColor: "success",
          statusIcon: "local_shipping",
          comment: {
            title: `Comment from ${displayName}:`,
            details:
              "This order has shipped! Visit the link below and use your tracking number to track your package.",
          },
          tracking: {
            name: trackingObj.shippingCo,
            link: shippingCoLinks[trackingObj.shippingCo],
            numb: trackingObj.tracking,
          },
          isLast: true,
        };

        console.log(trackingObj);

        const orderDocRef = doc(db, `${currentStudy}_ORDERS`, element.id);

        const updateBody = {
          lastModified: today,
          status: "shipped",
          statusDetails: `${element.orderId} has been shipped. Status changed by ${displayName}`,
          statusColor: "success",
          statusTimeline: arrayUnion(timelineItem),
        };

        await updateDoc(orderDocRef, updateBody);

        const sendmailApi =
          "https://q1bgx99bv9.execute-api.us-east-1.amazonaws.com/default/storefront_sendmail_orderflow";

        const body = JSON.stringify({
          senderName: displayName,
          senderEmail: element.orderFor,
          senderOrderNumb: element.orderId,
          senderStudy: element.storeData.title,
          senderRoute: "order-shipped",
          senderTrackingNumb: trackingObj.tracking,
          senderTrackingLink: shippingCoLinks[trackingObj.shippingCo],
        });

        console.log("BODY >>>", body);

        const requestOptions = {
          method: "post",
          body,
        };

        fetch(sendmailApi, requestOptions)
          .then((response) => {
            if (!response.ok) throw new Error("Error in fetch");
            return response.json();
          })
          .then((response) => {
            console.log(response);
            console.log("Sent to Lambda successfully!");
          })
          .catch((error) => {
            console.log(error);
            console.log("Email didn't work!");
          });

        const variant = "success";
        enqueueSnackbar(`${element.orderId}'s status has been updated!`, {
          variant,
          autoHideDuration: 2000,
        });
      }
      navigate("/");
      // const refreshedTrackingMap = trackingMap.filter((obj) => obj.status !== "shipped");
      // setTrackingMap(refreshedTrackingMap);
    }
  };

  const trackingCards = (
    <>
      <MDBox p={2} mt={3}>
        <MDButton
          variant="outlined"
          color="secondary"
          size="small"
          onClick={() => {
            setState("choose_study");
          }}
        >
          <Icon>arrow_back_ios</Icon>
        </MDButton>
      </MDBox>
      <MDBox p={2}>
        <Grid container sx={{ m: 0, p: 0 }}>
          {trackingMap.map((el) => (
            <MDBox py={2}>
              <Grid item xs={12} m={2}>
                <MDBox py={2} px={2} borderRadius={5}>
                  <MDTypography variant="h6">Order #: {el.orderId}</MDTypography>
                </MDBox>
                <MDBox py={2} px={2} borderRadius={5} bgColor="light">
                  <MDTypography variant="h6">Shipping Information</MDTypography>
                  <MDTypography variant="body2" sx={{ fontSize: ".75rem" }}>
                    {el.shippingAddress.email}
                    <br />
                    {el.shippingAddress.phone}
                    <br />
                    <Divider sx={{ margin: ".2rem" }} />
                    <strong>Attention: </strong>
                    {el.shippingAddress.attn}
                    <br />
                    {el.shippingAddress.addressLine1}
                    <br />
                    {el.shippingAddress.addressLine2.length === 0 ? (
                      ""
                    ) : (
                      <>
                        {el.shippingAddress.addressLine2} <br />
                      </>
                    )}
                    {el.shippingAddress.addressLine3.length === 0 ? (
                      ""
                    ) : (
                      <>
                        {el.shippingAddress.addressLine3} <br />
                      </>
                    )}
                    {el.shippingAddress.city}, {el.shippingAddress.state}
                    <br />
                    {el.shippingAddress.zip}
                    <br />
                    {el.shippingAddress.country}
                  </MDTypography>
                </MDBox>
                <MDBox py={2} px={2} borderRadius={5}>
                  <MDBox pt={2} pb={3}>
                    <MDTypography variant="body2" color="dark" sx={{ display: "inline" }}>
                      Choose Carrier:{" "}
                    </MDTypography>
                    <NativeSelect
                      onChange={(e) => {
                        setShippingCo(el.orderId, e.target.value);
                      }}
                      defaultValue="none"
                      inputProps={{
                        name: "shipping company select",
                        id: "uncontrolled-native",
                      }}
                      sx={{ width: "100%" }}
                    >
                      <option value="fedex">Fedex</option>
                      <option value="ups">UPS</option>
                      <option value="dhl">DHL</option>
                    </NativeSelect>
                  </MDBox>
                  <MDInput
                    type="text"
                    label="Tracking #"
                    onChange={(e) => {
                      setTrackingNumb(el.orderId, e.target.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </MDBox>
              </Grid>
            </MDBox>
          ))}
        </Grid>
        <MDBox py={2}>
          <MDButton
            variant="contained"
            color="info"
            onClick={() => {
              saveAll();
              // const docRef = doc(db, "cities", "DC");

              // await updateDoc(docRef, {
              //  key : true,
              // });
            }}
          >
            Save Tracking Numbers
          </MDButton>
        </MDBox>
      </MDBox>
    </>
  );

  //   <MDBox pt={2} pb={3}>
  //   <MDTypography variant="body2" color="dark" sx={{ display: "inline" }}>
  //     Choose Carrier:{" "}
  //   </MDTypography>
  //   <NativeSelect
  //     onChange={(e) => {
  //       setShippingCo(e.target.value);
  //     }}
  //     defaultValue="none"
  //     inputProps={{
  //       name: "shipping company select",
  //       id: "uncontrolled-native",
  //     }}
  //     sx={{ width: "100%" }}
  //   >
  //     <option value="fedex">Fedex</option>
  //     <option value="ups">UPS</option>
  //     <option value="usps">USPS</option>
  //     <option value="dhl">DHL</option>
  //   </NativeSelect>
  //   <MDInput
  //     type="text"
  //     label="Tracking Number"
  //     value={trackingNumb}
  //     onChange={(e) => {
  //       setTrackingNumb(e.target.value);
  //     }}
  //     style={{ width: "100%", marginTop: "1rem" }}
  //   />
  // </MDBox>

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                {currentStudy.replace(/_/g, " ")} Orders
              </MDTypography>
            </MDBox>
            <MDBox p={2}>
              <Grid container spacing={3}>
                {state === "choose_study" &&
                  userStudies.map((el) => (
                    <Grid item xs={12} sm={8} md={2}>
                      <MDBox py={2}>
                        <MDButton
                          variant="contained"
                          color="info"
                          size="large"
                          fullWidth
                          onClick={() => {
                            setCurrentStudy(dispatch, el);
                            setState("study");
                          }}
                        >
                          {el.replace(/_/g, " ")}
                        </MDButton>
                      </MDBox>
                    </Grid>
                  ))}
              </Grid>
              {state === "study" && trackingCards}
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default TrackingSheet;
